import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormSwitchButtonComponent } from '@shared/controls/form-switch-button/form-switch-button.component';
import { InputComponent } from '@shared/controls/input/input.component';
import { LinkComponent } from '@shared/components/commons/link/link.component';
import { ValidationErrorComponent } from '@shared/controls/validation-error/validation-error.component';
import { CustomFormValidators } from "../../validators/custom-form-validators";

@Component({
  selector: 'app-input-password',
  standalone: true,
  imports: [
    ValidationErrorComponent,
    FormsModule,
    NgbTooltip
  ],
  templateUrl: './input-password.component.html',
  styleUrls: ['./input-password.component.scss', '../input/input.component.scss']
})
export class InputPasswordComponent extends InputComponent implements OnInit {
  @Input() passwordVisible = false;
  @Input() override customErrors: Record<string, string> = { onlyLettersAndNumbersAllowed: 'Only letters and numbers are allowed.' };

  ngOnInit(): void {
    if (this.ngControl.control) {
      this.ngControl.control.addValidators([CustomFormValidators.onlyLettersAndNumbersAllowedValidator]);
    }
  }

  get type(): string {
    return this.passwordVisible ? 'text' : 'password';
  }

  get showPasswordIconClass(): string {
    return this.passwordVisible ? 'ic-eye-off-16' : 'ic-eye-16';
  }

  get hidePasswordIcon(): boolean {
    return !this.ngControl?.control?.value;
  }
}
